export const paths = {
  CONFIRM_EMAIL_CHANGE: "/confirm-email-change",
  FORGOT: "/forgot",
  RESET: "/reset",
  LOGIN: "/login",
  HOME: "/"
}
